var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopborder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1914 578",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#Gradient_3-4);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #ffde83;\r\n        mix-blend-mode: soft-light;\r\n        opacity: .5;\r\n      }\r\n\r\n      .cls-12 {\r\n        isolation: isolate;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#Gradient_3);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #080610;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: #ffe600;\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: url(#Gradient_3-3);\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: url(#linear-gradient-4);\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: url(#Gradient_3-2);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_3",
    "data-name": "Gradient 3",
    x1: 478.38,
    y1: 536.89,
    x2: 478.38,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0a0515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b1c31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_3-2",
    "data-name": "Gradient 3",
    x1: 656.23,
    y1: 536.89,
    x2: 656.23,
    gradientTransform: "translate(2091.85) rotate(-180) scale(1 -1)",
    xlinkHref: "#Gradient_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_3-3",
    "data-name": "Gradient 3",
    x1: 478.38,
    y1: 140.7,
    x2: 478.38,
    y2: -396.19,
    gradientTransform: "translate(0 677.59) scale(1 -1)",
    xlinkHref: "#Gradient_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_3-4",
    "data-name": "Gradient 3",
    x1: 656.23,
    y1: 140.7,
    x2: 656.23,
    y2: -396.19,
    gradientTransform: "translate(2091.85 677.59) rotate(-180)",
    xlinkHref: "#Gradient_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 556.32,
    y1: 31.1,
    x2: 556.32,
    y2: 15.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fa0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 612.2,
    y1: 31.1,
    x2: 612.2,
    y2: 15.73,
    gradientTransform: "translate(1974.31) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1902.41,
    y1: 673.86,
    x2: 1902.41,
    y2: 360.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1365.94,
    y1: 673.86,
    x2: 1365.94,
    y2: 360.52,
    gradientTransform: "translate(1379.07) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m957,2.18S75.46,1.5,72.61.04C69.76-1.43,5.24,42.63,1.44,50.56c-3.8,7.93,0,486.33,0,486.33h43.44l.63-200.48s-20.35-69.94-23.2-92.85c-2.85-22.91-4.75-180.66-2.37-185.94,2.37-5.29,51.24-39.22,59.31-40.98,8.07-1.76,222.36-.44,226.79,1.32,4.43,1.76,27.83,19.97,34.16,22.33,6.33,2.35,419.42,5.04,430.81,2.81,11.39-2.23,27.52-21.61,32.26-24.26,4.74-2.64,153.72,0,153.72,0V2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m957,2.18S1838.54,1.5,1841.39.04c2.85-1.47,67.37,42.6,71.17,50.53,3.8,7.93,0,486.33,0,486.33h-43.44l-.63-200.48s20.35-69.94,23.2-92.85c2.85-22.91,4.74-180.66,2.37-185.94-2.37-5.29-51.24-39.22-59.31-40.98-8.07-1.76-222.36-.44-226.79,1.32-4.43,1.76-27.83,19.97-34.16,22.33-6.33,2.35-419.42,5.04-430.81,2.81-11.39-2.23-27.52-21.61-32.26-24.26-4.74-2.64-153.72,0-153.72,0V2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m957,1071.61s-881.54.67-884.39,2.14c-2.85,1.47-67.37-42.6-71.17-50.53-3.8-7.93,0-486.33,0-486.33h43.44l.63,200.48s-20.35,69.94-23.2,92.85c-2.85,22.91-4.75,180.66-2.37,185.94,2.37,5.29,51.24,39.22,59.31,40.98,8.07,1.76,222.36.44,226.79-1.32,4.43-1.76,27.83-19.98,34.16-22.33,6.33-2.35,419.42-5.04,430.81-2.82,11.39,2.23,27.52,21.61,32.26,24.26s153.72,0,153.72,0v16.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m957,1071.61s881.54.67,884.39,2.14c2.85,1.47,67.37-42.6,71.17-50.53,3.8-7.93,0-486.33,0-486.33h-43.44l-.63,200.48s20.35,69.94,23.2,92.85c2.85,22.91,4.74,180.66,2.37,185.94-2.37,5.29-51.24,39.22-59.31,40.98-8.07,1.76-222.36.44-226.79-1.32-4.43-1.76-27.83-19.98-34.16-22.33-6.33-2.35-419.42-5.04-430.81-2.82-11.39,2.23-27.52,21.61-32.26,24.26s-153.72,0-153.72,0v16.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m334.04,10.47s22.3,20.71,24.2,20.71,394.75,1.76,399.49,0c4.74-1.76,22.77-20.71,22.77-20.71h-446.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m345.9,15.73s13.28,14.1,15.66,14.98c2.37.88,382.89,0,387.63,0s17.55-14.98,17.55-14.98h-420.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m1584.39,10.47s-22.3,20.71-24.2,20.71-394.75,1.76-399.49,0c-4.74-1.76-22.77-20.71-22.77-20.71h446.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m1572.53,15.73s-13.28,14.1-15.66,14.98c-2.37.88-382.89,0-387.63,0s-17.55-14.98-17.55-14.98h420.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m22.32,830.23s.32-95.38.63-98.9c.32-3.52,10.75-48.03,10.75-48.03l11.81-346.89v400.97l-23.2,92.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m18.94,118.68l-5.16-51.82-12.34,2.64S70.71,13.55,74.51,10.47c3.8-3.08,169.38,5.94,169.38,5.94,0,0-158.94.23-164.63.23S22.32,54.97,19.95,57.61c-2.37,2.64-1.01,61.07-1.01,61.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m-.24,329.48s17.6,23.35,23.88,48.03c6.28,24.67-6.11,319.45-6.11,319.45l-17.01-20.71L-.24,329.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m1891.37,830.23s-.32-95.38-.63-98.9c-.32-3.52-10.75-48.03-10.75-48.03l-11.81-346.89v400.97l23.2,92.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m1913.93,329.48s-17.6,23.35-23.88,48.03c-6.28,24.67,6.11,319.45,6.11,319.45l17.01-20.71.76-346.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m358.23,31.17s13.21-13.84,177.92-15.45c164.71-1.61,215.92,16.23,215.92,16.23l-393.84-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1169.24,30.71s62.95-9.72,176.62-14.98c113.67-5.26,205.54,10.12,205.54,10.12l-382.16,4.86Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m1908.5,352.51s-10.81,20.65-10.81,26.43,1.81,294.92,1.81,294.92c0,0,6.23-16.39,9-24.1,2.77-7.71,0-297.25,0-297.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m1904.52,360.52s5.03,227.2,1.39,296.3l-6.41,17.04s-2.48-291.44-1.81-294.92c.67-3.49,6.82-18.42,6.82-18.42Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m7.03,352.51s10.81,20.65,10.81,26.43-1.81,294.92-1.81,294.92c0,0-6.23-16.39-9-24.1-2.77-7.71,0-297.25,0-297.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m11.02,360.52s-5.03,227.2-1.39,296.3l6.41,17.04s2.48-291.44,1.81-294.92-6.82-18.42-6.82-18.42Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopborder);
export default __webpack_public_path__ + "static/media/topborder.acda0498bf766269b2fea95f4bcab2fb.svg";
export { ForwardRef as ReactComponent };